/* eslint-disable @typescript-eslint/naming-convention */
import { SCREEN_NAME, IMPRESSION_ACTIONS } from "../constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const impressionCartHeaderLottieExpress = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    freqCap: number,
    timeSeen: number,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.EXPRESS_CHECKOUT_ANIMATION_IMPRESSION,
        context: JSON.stringify({
            frequency_cap: freqCap,
            times_seen: timeSeen,
        }),
    });
};

export const impressionCartHeaderLottieOtg = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    freqCap: number,
    timeSeen: number,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.OTG_CHECKOUT_ANIMATION_IMPRESSION,
        context: JSON.stringify({
            frequency_cap: freqCap,
            times_seen: timeSeen,
        }),
    });
};

export const impressionCartHeaderLottieBolt = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.BOLT_CHECKOUT_ANIMATION_IMPRESSION,
        context,
    });
};

export const impressionCartHeaderLottie = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.HEADER_CHECKOUT_ANIMATION_IMPRESSION,
        context,
    });
};

export interface ToingRtbBannerImpressionParams {
    sid: string;
    cartId: string;
    originalCartId: string;
}

export const impressionToingRtbBanner = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    { sid, cartId, originalCartId }: ToingRtbBannerImpressionParams,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.TOING_CHECKOUT_RTB_BANNER_IMPRESSION,
        context: JSON.stringify({ sid }),
        extraParams: JSON.stringify({ cart_id: cartId, originalCartId }),
    });
};
